import { analyticsOperationsService } from "@/services/analytics-operations-service";
import { downloadBlob } from "@/utils/downloadFile";

type OperationsExportParams = {
  hotelId: string;
  from: string;
  to: string;
  format: "csv" | "xlsx";
};

export async function downloadOperationsTotalRequestsExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportTotalRequests(params);
  downloadBlob(
    blob,
    `total-requests-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsProcessingTimeExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportProcessingTime(params);
  downloadBlob(
    blob,
    `processing-time-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsApprovalTimeExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportApprovalTime(params);
  downloadBlob(
    blob,
    `approval-time-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsOnTimeRateExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportOnTimeRate(params);
  downloadBlob(
    blob,
    `on-time-rate-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsComplaintsExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportComplaints(params);
  downloadBlob(
    blob,
    `complaints-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsUnderestimatedServicesExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob =
    await analyticsOperationsService.exportUnderestimatedServices(params);
  downloadBlob(
    blob,
    `underestimated-services-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadOperationsOnHoldCanceledExport(
  params: OperationsExportParams,
): Promise<void> {
  const blob = await analyticsOperationsService.exportOnHoldCanceled(params);
  downloadBlob(
    blob,
    `on-hold-canceled-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}
